import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Record_overview extends PureComponent {
  render() {
    return (
      <div className="row" id="record_overview">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Record Overview</h2>
              <p>
                The record management functions allow users to create, read,
                update, delete, replace and search records. Record IDs are
                sequential numbers and generate automatically. The URL format is
                always <strong>v1/record/object_type</strong>. Object Types are
                like tables in SQL. You can create a record of a new Object Type
                without any prior Object Type setup providing you are an
                Administrator. Object Type names must be at least 3 characters
                and a limited to a maximum of 196 characters. They can contain
                letters, numbers and underscores. Object Types are always
                lowercase.
              </p>
              <p>
                In all the examples below we will leave the object_type part of
                the URL as just object_type. As with all the API functions, you
                will need to get your API URL. For the purpose of these
                examples, we will just use example.api.nexoid.com. In the
                examples will make the Session_ID{" "}
                <span className="code jsonO">
                  &#123;&#123;session_id&#125;&#125;
                </span>{" "}
                to make it easier to use with Postman. The{" "}
                <span className="code jsonO">
                  &#123;&#123;session_id&#125;&#125;
                </span>{" "}
                will need to be replaced with a valid Session ID in any other
                situation.
              </p>
              <p>
                Nexoid API supports using the request body or URL query string
                for passing data to the API. In most examples, you are better
                using the body of the request as you can put in multiple layered
                objects, however, in examples like the{" "}
                <span className="methodCodeGET fs16">GET</span> request, the
                HTML standard does not support a request body. You will need to
                use a query string is required to pass the Session_ID parameter.
              </p>
              <p>
                All record management functions require a valid Session_ID and
                the correct permissions for that object_type and/or record level
                permission for that record. Permissions can be managed at an
                object level or a record level permission level. Records level
                permissions are stored in a text array called{" "}
                <strong>array_text_rlp</strong>.
              </p>
              <p>
                All data stored in the database must follow the{" "}
                <PageLink to="/overview#db_naming" text="Field Naming Schema" />
                .
              </p>
              <p>
                Fields are automatically created on-demand however you are
                limited to 1000 unique Fields. This can cause problems when
                inserting objects straight into a record. If you need to insert
                an object into a record that is large or has an unknown
                structure, it is best to put it into a text field as a JSON
                string. You will see Nexoid API does this in the Audit record
                function.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol ">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Record_overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Record_overview.js